import { AxiosPromise } from 'axios';

import { axios } from 'src/app/utils';
import { urlsConfig } from 'src/configs';
import { serviceLocals } from 'src/locals';
import { queryTypes, serviceWorkPackageTypes } from 'src/types';
import { fileHelper, urlHelper } from 'src/app/helpers/';

export const lookupWorkPackage = ({
  limit,
  offset,
  ids,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
  search,
}: serviceWorkPackageTypes.WorkPackageLookupDataType): AxiosPromise<serviceWorkPackageTypes.WorkPackageLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }
  if (search) {
    query.search = search.join(',');
  }
  if (value) {
    query.search = value;
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  if (limit && offset) {
    query.limit = limit;
    query.offset = offset;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.workPackage.lookupWorkPackage), {
    blockSpinner,
  });
};

export const lookupWorkPackageWithEvent = ({
  limit,
  offset,
  ids,
  eventIds,
  value,
  order,
  sortOrder,
  blockSpinner,
  load,
  search,
}: serviceWorkPackageTypes.WorkPackageLookupDataType): AxiosPromise<serviceWorkPackageTypes.WorkPackageLookupResultType> => {
  const query: queryTypes.LookupQueryParametersType = {};

  if (ids) {
    query.ids = ids.join(',');
  }
  if (search) {
    query.search = search.join(',');
  }
  if (value) {
    query.search = value;
  }
  if (eventIds) {
    return axios.get(`${urlsConfig.workPackage.lookupWorkPackage}?eventIds=${eventIds}`, {
      blockErrorHandler: true,
    });
  }

  if (order && sortOrder) {
    query.order = order;
    query.sortOrder = sortOrder;
  }

  return axios.get(urlHelper.addQueryParameters(query, urlsConfig.workPackage.lookupWorkPackage), {
    blockSpinner,
  });
};

export const workPackageAdd = (
  form: serviceWorkPackageTypes.WorkPackageCreateDataType,
  // formData: FormData,
  options: { blockErrorHandler: boolean },
): AxiosPromise<serviceWorkPackageTypes.WorkPackageCreateResultType> => {
  const formData = fileHelper.convertDataURLsToFormData(form.attachments);

  if (form.eventId) {
    formData.append('eventId', form.eventId);
  }

  if (form.workPackageNumber) {
    formData.append('workPackageNumber', form.workPackageNumber);
  }

  if (form.workPackageName) {
    formData.append('workPackageName', form.workPackageName);
  }

  if (form.workPackageManagerId) {
    formData.append('workPackageManagerId', form.workPackageManagerId);
  }

  if (form.projectId) {
    formData.append('projectId', form.projectId);
  }

  if (form.description) {
    formData.append('description', form.description);
  }

  if (form.log) {
    formData.append('log', form.log.join(','));
  }

  if (form.comment) {
    formData.append('comment', form.comment);
  } else {
    formData.append('comment', '');
  }

  return axios.post(urlsConfig.workPackage.workPackageAdd, formData, { headers: serviceLocals.formDataHeader });
};

export const workPackageEdit = (
  form: serviceWorkPackageTypes.WorkPackageEditDataType,
  deletedAttachments: string[],
  // formData: FormData,
): AxiosPromise<serviceWorkPackageTypes.WorkPackageEditDataType> => {
  const formData = fileHelper.convertDataURLsToFormData(form.attachments);

  if (form.id !== undefined) {
    formData.append('id', form.id);
  }

  if (deletedAttachments !== undefined) {
    deletedAttachments.forEach((eachAttachment: any) => {
      formData.append('deletedAttachments', eachAttachment);
    });
  }

  if (form.eventId) {
    formData.append('eventId', form.eventId);
  }

  if (form.workPackageNumber) {
    formData.append('workPackageNumber', form.workPackageNumber);
  }

  if (form.workPackageName) {
    formData.append('workPackageName', form.workPackageName);
  }

  if (form.workPackageManagerId) {
    formData.append('workPackageManagerId', form.workPackageManagerId);
  }

  if (form.projectId) {
    formData.append('projectId', form.projectId);
  }

  if (form.description) {
    formData.append('description', form.description);
  } else {
    formData.append('description', '');
  }

  if (form.log) {
    formData.append('log', form.log.join(','));
  }

  if (form.comment) {
    formData.append('comment', form.comment);
  } else {
    formData.append('comment', '');
  }
  return axios.patch(urlsConfig.workPackage.workPackageEdit, formData, { blockErrorHandler: true });
};

export const workPackageDelete = ({
  id,
}: serviceWorkPackageTypes.WorkPackageDeleteDataType): AxiosPromise<serviceWorkPackageTypes.WorkPackageDeleteResultType> => {
  return axios.delete(`${urlsConfig.workPackage.workPackageDelete}/${id}`);
};
